import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)({
        width: void 0,
        height: void 0
    });
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
const use_window_size = useWindowSize;
export { use_window_size as default };
